import React from "react";
import PropTypes from "prop-types";

const StatusCards = ({ items }) => (
  <div className="row g-3 mb-3">
    {items.map((item) => {
      const toneClass = item.tone === "success" ? "is-success" : "is-warning";
      const subtitle = item.subTitle || item.subtitle;
      return (
      <div className="col-12 col-md-6 col-xl-3" key={item.id}>
        <div className={`convocacao-status-card h-100 ${toneClass}`}>
          <div className="convocacao-status-icon">
            <i className="feather-user" />
          </div>
          <div className="convocacao-status-content">
            <div className="convocacao-status-title">{item.title}</div>
            <div className="convocacao-status-subtitle">{subtitle}</div>
            <div className="convocacao-status-value">{item.value}</div>
          </div>
        </div>
      </div>
    );
    })}
  </div>
);

StatusCards.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      subTitle: PropTypes.string,
      subtitle: PropTypes.string,
      tone: PropTypes.string,
      categorias: PropTypes.string,
    }),
  ).isRequired,
};

export default StatusCards;
